import { render } from "./Switchboard.vue?vue&type=template&id=73f94b47&scoped=true"
import script from "./Switchboard.vue?vue&type=script&lang=js"
export * from "./Switchboard.vue?vue&type=script&lang=js"

import "./Switchboard.vue?vue&type=style&index=0&id=73f94b47&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f94b47"]])

export default __exports__